'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wholeMinutesOrSeconds = wholeMinutesOrSeconds;
function pluralizeUnitString(value, unit) {
  return value + ' ' + unit + (value !== 1 ? 's' : '');
}
function wholeMinutesOrSeconds(ms) {
  // Return '1 minute' or '59 seconds'
  // but never '60 seconds'
  if (ms < 60 * 1000) {
    return pluralizeUnitString(Math.floor(ms / 1000), 'second');
  }
  return pluralizeUnitString(Math.ceil(ms / 1000 / 60), 'minute');
}